module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar"
  }, [_c('logo'), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-custom"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li-title')], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('li-loader', {
    staticClass: "hidden-sm-down"
  }), _vm._v(" "), _c('main-custom-top-bar'), _vm._v(" "), _c('li-account')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30bf6173"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/MainTopBar.vue
// module id = 682
// module chunks = 1